export default "__VITE_ASSET__B7elqStW__"